import {
  ASSET_CREATE_MAX_IMAGE_FILE_BYTES,
  ASSET_CREATE_MAX_IMAGE_FILES,
} from '../constants/assetCreateUpload';

export type AssetCreateImageLimitMessages = {
  tooMany: (max: number) => string;
  tooLarge: (fileName: string, sizeMb: string, maxMb: number) => string;
};

const DEFAULT_MESSAGES: AssetCreateImageLimitMessages = {
  tooMany: (max) => `You can attach at most ${max} image files (server limit).`,
  tooLarge: (fileName, sizeMb, maxMb) =>
    `Image “${fileName}” is ${sizeMb} MB; each file must be at most ${maxMb} MB.`,
};

export function assertAssetCreateImageFilesWithinLimits(
  files: readonly File[],
  messages: AssetCreateImageLimitMessages = DEFAULT_MESSAGES,
): void {
  if (files.length > ASSET_CREATE_MAX_IMAGE_FILES) {
    throw new Error(messages.tooMany(ASSET_CREATE_MAX_IMAGE_FILES));
  }
  const mb = ASSET_CREATE_MAX_IMAGE_FILE_BYTES / (1024 * 1024);
  for (const f of files) {
    if (f.size > ASSET_CREATE_MAX_IMAGE_FILE_BYTES) {
      throw new Error(
        messages.tooLarge(f.name, (f.size / (1024 * 1024)).toFixed(1), mb),
      );
    }
  }
}
